/**
 * Listen to an event on the given DOM node. Returns a callback to remove the event listener.
 */
function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

var findShadowRoot = function findShadowRoot(el) {
  if (el instanceof ShadowRoot) return el;
  if (!el.parentNode) return null;
  return findShadowRoot(el.parentNode);
};

var isColliding = function isColliding(a, b) {
  var translateAx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var translateAy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var translateBx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var translateBy = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var aRect = a.getBoundingClientRect();
  var bRect = b.getBoundingClientRect();
  return aRect.left + translateAx < bRect.right + translateBx && aRect.right + translateAx > bRect.left + translateBx && aRect.top + translateAy < bRect.bottom + translateBy && aRect.bottom + translateAy > bRect.top + translateBy;
};

var buildNoAncestorSelector = function buildNoAncestorSelector(root, ancestor, selector, depth) {
  var baseQuery = function baseQuery(modifier) {
    return "".concat(root, " > ").concat(modifier, " ").concat(selector, ", ");
  };

  var buildQuery = function buildQuery() {
    var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return baseQuery(":not(".concat(ancestor, ") >").repeat(deep));
  };

  var query = buildQuery(1);

  for (var i = 2; i < depth + 1; i += 1) {
    query += buildQuery(i);
  }

  return query.slice(0, -2);
};

export { buildNoAncestorSelector as b, findShadowRoot as f, isColliding as i, listen as l };